export default "__VITE_ASSET__C8ZXfd6A__"